import { render, staticRenderFns } from "./ListApprovisionnement.vue?vue&type=template&id=37b5fd51"
import script from "./ListApprovisionnement.vue?vue&type=script&lang=js"
export * from "./ListApprovisionnement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports